export const filters = {
  sideMenu: [
    {
      name: "Doctor Name",
      value: "doctorNameStatus",
    },
    {
      name: "Upcomming Appointment",
      value: "appointmentStatus",
    },
  ],
  doctorNameStatus: [
    
  ],
  appointmentStatus: [
    {
      name: "All",
      value: "all",
    },
    {
      name: "Upcoming",
      value: "upcoming",
    },
  ],
};